/**
 * Smooth Scroll when click on link
 * @dependencies jump.js
 * @dependencies ez.js
 */

import Jump from 'jump.js';
import { easeOutQuart } from 'ez.js';

const links = document.getElementsByClassName('js-smooth-scroll');
const anchorsEl = document.querySelector('.js-fixed-anchors');
let jumpOffset = 0;

for (let index = 0; index < links.length; index++) {
  const el = links[index];
  const url = el.getAttribute('href');
  const hash = url.substring(url.indexOf('#') + 1);
  const duration = el.getAttribute('data-jump-duration') ? el.getAttribute('data-jump-duration') : 800;

  el.addEventListener('click', (ev) => {
    ev.preventDefault();

    // Jump offset calculation
    let targetEl = document.getElementById(hash);
    jumpOffset = anchorsEl.offsetHeight + parseInt(window.getComputedStyle(targetEl).getPropertyValue('margin-top'));

    // Temporary disables scroll behavior & freezes header
    document.documentElement.style.setProperty('scroll-behavior', 'auto');
    window.fixedHeader.unpin();
    window.fixedHeader.freeze();

    Jump(`#${hash}`, {
      duration: duration,
      easing: easeOutQuart,
      offset: -jumpOffset,
      callback: function () {
        document.documentElement.style.setProperty('scroll-behavior', 'smooth');
        window.fixedHeader.unfreeze();
      },
    });
  });
}
